import React from "react";

/**
 * Shared loading skeleton block. Compose several into a layout-shaped
 * placeholder instead of a full-screen spinner. Uses the `.kids-sk`
 * shimmer keyframe defined in index.css.
 */
export default function Skeleton({ className = "", style, rounded = "16px" }) {
  return (
    <div
      className={`kids-sk ${className}`}
      style={{ borderRadius: rounded, ...style }}
    />
  );
}
